/* eslint-disable react/no-unknown-property */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
 

import { nanoid } from "nanoid";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import "./Sheet.css";
import { normalizeBase64Image } from "./utils";

const Cursor = forwardRef(function Cursor(props, ref) {
  return (
    <div
      ref={ref}
      style={{
        pointerEvents: "none",
        position: "absolute",
        visibility: "hidden",
        width: 2 * props.size,
        height: 2 * props.size,
        border: "1px solid #2b2b2b",
        borderRadius: "100%",
      }}
    />
  );
});

function Canvas(props) {
  const key = props?.id || nanoid(5);
  let painting = false;

  const cursorElem = useRef();
  const { size: brushSize, color: brushColor, active } = props.brush;

  useEffect(() => {
    const [width, height] = [props.size[0], props.size[1]];
    const canvas = window?.pdfDoc?.getElementById(`canvas-sheet-${key}`);
    const ctx = canvas.getContext("2d");

    // ctx.lineWidth = 0.26;
    console.log(width, height, canvas.width, canvas.height);

    const image = new Image();
    image.src = normalizeBase64Image(props.data.layout);
    image.style.width = "100%";
    image.style.height = "100%";
    image.onload = () => {
      ctx.drawImage(image, 0, 0, width, height);
    };

    // ctx.strokeStyle = "#fff";
    ctx.save();

    return () => window?.pdfDoc?.removeEventListener("mouseup", handleMouseUp);
  }, []);

  function getCoordinates(e) {
    const canvas = window?.pdfDoc?.getElementById(`canvas-sheet-${key}`);
    const boundings = canvas.getBoundingClientRect();
    const x = e.clientX - boundings.left;
    const y = e.clientY - boundings.top;

    return { x, y };
  }

  function handleMouseDown(e) {
    e.preventDefault();
    // console.log(e);
    if (e.nativeEvent.which !== 1 || active === false) {
      return;
    }
    const canvas = window?.pdfDoc?.getElementById(`canvas-sheet-${key}`);
    const ctx = canvas.getContext("2d");

    painting = true;
    const { x, y } = getCoordinates(e);
    ctx.fillStyle = brushColor;

    ctx.beginPath();
    // ctx.moveTo(x, y);
    // ctx.lineTo(x, y);

    ctx.arc(x, y, brushSize, 0, 2 * Math.PI);
    // ctx.stroke();
    ctx.fill();
    ctx.closePath();
    ctx.save();
  }

  function handleMouseMove(e) {
    e.preventDefault();
    const { x, y } = getCoordinates(e);
    if (active) {
      cursorElem.current.style.visibility = "visible";
      cursorElem.current.style.transform = `translate(${x - brushSize}px, ${
        y - brushSize
      }px)`;
    }

    if (!painting) {
      return;
    }
    const canvas = window?.pdfDoc?.getElementById(`canvas-sheet-${key}`);
    const ctx = canvas.getContext("2d");

    // ctx.lineTo(x, y);
    // console.log(e);
    // ctx.save();
    ctx.beginPath();
    // ctx.moveTo(x, y);
    // ctx.lineTo(x, y);
    ctx.arc(x, y, brushSize, 0, 2 * Math.PI);
    // ctx.stroke();
    ctx.closePath();
    ctx.fill();
    // ctx.restore();
    // ctx.fillStyle = "#fff";
    // console.log(canvas.toDataURL());
  }

  function handleMouseUp(e) {
    e.preventDefault();
    painting = false;
  }

  function handleMouseLeave() {
    cursorElem.current.style.visibility = "hidden";

    const canvas = window?.pdfDoc?.getElementById(`canvas-sheet-${key}`);
    const ctx = canvas.getContext("2d");
    ctx.restore();
  }

  window?.pdfDoc?.addEventListener("mouseup", handleMouseUp, false);

  return (
    <div className="pdf-sheet-wrap">
      <div style={{ width: 12, height: "100%", background: "none" }} />

      <div style={{ cursor: active ? "none" : "default" }}>
        <Cursor ref={cursorElem} size={brushSize} active={active} />
        <canvas
          id={`canvas-sheet-${key}`}
          key={key}
          className="pdf-sheet"
          dataindex={props.index}
          datakey={key}
          width={props.style.width}
          height={props.style.height}
          style={{ ...props.style }}
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
        />
      </div>
    </div>
  );
}

export default Canvas;
